<template>
  <div v-show="authenticated || SubHeader == 'FreqAsk'" class="transition : 1s">
    <div
      class="residentportal-header-login"
      ref="residentportal-header-login"
      v-bind:style="'background:' + computedBackgroundRGB + 'flex: 1'"
    >
      <Header :isReducedView="true" />
      <div class="container">
        <div class="row">
          <div class="col-lg-12 residentportal-subheader">
            <BookServiceHeader :isReducedView="true" />
          </div>
        </div>
      </div>
    </div>
    <div>
      <div class="container">
        <div class="text-danger text-center mb-4">{{ $store.getters.GET_SEARCHED_ADDRESSES.error }}</div>
        <div class="booking-service">
            <AddressPin :isReducedView="true" />

            <template v-if="selectedAddressId">
              <entitlement-table-history  :addressId="Number(selectedAddressId)" customClass="pt-4 mb-4" />
            </template>

            <!-- CONTENT HERE -->
            <AddressDetailsTable :addressId="selectedAddressId" class="mt-4"/>
        </div>
      </div>
    </div>
    <MainFooter />
    <div
      class="modal"
      tabindex="-1"
      role="dialog"
      id="pageLoadingModal"
      data-backdrop="static"
    >
      <div
        class="modal-dialog modal-dialog-centered"
        role="document"
        style="height: 150px; flex-direction: column-reverse"
      >
        <p class="text-white mt-3">
          {{ TEXTS.render(`BOOKING_LOADING_NOTE`) }}
        </p>
        <h3 class="text-white mt-3">{{ TEXTS.render(`BOOKING_LOADING`) }}</h3>
        <div style="margin-top: 40%">
          <PageLoadingIndicator />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import GeneralBookingSettingMixin from "../common/mixins/GeneralBookingSettingMixin";
import PageLoadingIndicator from "../common/components/PageLoadingIndicator";
import BookServiceHeader from "../common/components/BookServiceHeader";
import Header from "../common/components/Header";
import MainFooter from "../common/components/Footer";
import InactivityDetection from "../common/components/InactivityDetection";
import BookingStateManager from "../common/utils/BookingStateManager";
import RetryWorker from "../common/utils/RetryWorker";
import AccessibilityManager from "../common/utils/AccessibilityManager";
import Texts from "../common/utils/Texts";

import AddressPin from "../modules/booking/home/components/AddressPin"
import BookingSearch from "../common/components/BookingSearch"
import AddressDetailsTable from "../common/components/AddressDetailsTable"
import EntitlementTableHistory from '../common/components/EntitlementTableHistory';

const MyProfile = { template: Texts.render(`BOOKING_SECTION_HEADER_PROFILE`) };
const FreqAsk = { template: Texts.render(`BOOKING_SECTION_HEADER_FAQ`) };

const routeSubHeader = {
  "/booking/home": "BookServiceHeader",
  "/booking/my-profile": "MyProfile",
  "/booking/faq": "FreqAsk",
};

export default {
  mixins: [GeneralBookingSettingMixin],
  data() {
    return {
      pubPath: process.env.MIX_APP_URL,
      activeAddress: null,
      authenticated: false,
    };
  },
  components: {
    PageLoadingIndicator,
    Header,
    MainFooter,
    InactivityDetection,
    BookServiceHeader,
    MyProfile,
    FreqAsk,
    AddressPin,
    BookingSearch,
    AddressDetailsTable,
    EntitlementTableHistory
  },
  beforeCreate() {
    // Initialize Text Rendering Settings
    Texts.setModifiers({
      sentenceCase: true,
    });
  },
  mounted() {
    new AccessibilityManager();
    this.$store.dispatch("bookingInit").then((result) => {
      var email = this.personalInfo.email;
      if (email)
        this.checkAuthentication(email).then((result) => {
          if (result) {
            this.authenticated = true;
            // this.$store.dispatch("mainUI");
            // this.$store.dispatch("setActiveMultipleServiceBookingSetting");
          } else {
            this.$store.dispatch("logout");
          }
        });
    });
  },
  computed: {
    TEXTS: () => Texts,
    bookingState() {
      return this.$store.getters.GET_BOOKING_STATE;
    },
    personalInfo() {
      return this.$store.getters.GET_PERSONAL_INFO;
    },
    SubHeader() {
      return routeSubHeader[this.$route.fullPath];
    },
    MainUISettings() {
      return this.$store.getters["GET_MAIN_UI"];
    },
    computedBackgroundRGB() {
      var background =
        "linear-gradient(45deg, " +
        this.convertHex(this.$store.getters.GET_MAIN_UI.banner_gradient_dark) +
        " 25%, " +
        this.convertHex(this.$store.getters.GET_MAIN_UI.banner_gradient_light) +
        " 79%), url(" +
        process.env.MIX_APP_URL +
        this.$store.getters.GET_MAIN_UI.banner_image +
        " );";
      return background;
    },
    backgroundRGB() {
      var background =
        "linear-gradient(45deg, " +
        this.convertHex(this.$store.getters.GET_MAIN_UI.banner_gradient_dark) +
        " 25%, " +
        this.convertHex(this.$store.getters.GET_MAIN_UI.banner_gradient_light) +
        " 79%);";
      return background;
    },
    isInBookingForm() {
      return this.$route.fullPath.indexOf("/booking/form") > -1;
    },
    websiteTitle() {
      return this.$store.getters.GET_WEBSITE_METADATA.title;
    },
    secondsToTrigger() {
      // --- CR-3: Changing number of minutes to logout depending on the user type
      var secondsToTrigger;
      const userType = this.$store.getters.GET_PERSONAL_INFO.type;
      switch (userType) {
        case "cso":
          secondsToTrigger = 60 * 60 * 9; // 9 Hours
          break;
        default:
          secondsToTrigger = 60 * 60; // 1 Hour
      }

      return secondsToTrigger;
    },

    selectedAddressId(){
      return this.$store.getters.GET_ACTIVE_ADDRESS ? this.$store.getters.GET_ACTIVE_ADDRESS.id : null;
    }
  },
  methods: {
    convertHex(color) {
      color = color.replace("#", "");
      let r = parseInt(color.substring(0, 2), 16);
      let g = parseInt(color.substring(2, 4), 16);
      let b = parseInt(color.substring(4, 6), 16);
      let result = "rgba(" + r + "," + g + "," + b + "," + 0.75 + ")";
      return result;
    },

    //Loads active address to display on the banner;
    activeAddressName() {
      // Check Path
      var addressName = "";

      var hasFormInUrl = window.location.href.indexOf("/booking/form") != -1;
      var hasHistoryInUrl =
        window.location.href.indexOf("/booking/history") != -1;

      if (hasHistoryInUrl) {
        // If History, pull from URL id
        var bookingManager = new BookingStateManager();
        var urlQuery = this.$route.query;
        var addressId = urlQuery.id;
        var address = bookingManager.getAddressFromMapById(addressId);
        if (!address) {
          // Redirect Back to Home
          this.$router.push("/booking/home");
          location.reload();
        }
        addressName = address.displayName;
      } else if (hasFormInUrl) {
        // If in form, pull from booking State
        var bookingState = this.bookingState;
        if (bookingState.activeAddress) {
          addressName = bookingState.activeAddress.displayName;
        }
      }
      this.$store.dispatch("setBookingHistoryAddress", addressName);
      return addressName.toLowerCase();
    },
    changeAddress() {
      let route = this.$router.resolve({ path: "/booking/home" });
      if (this.$store.getters.GET_PERSONAL_INFO.type == "cso") {
        window.open(route.href, "_blank");
      } else {
        this.$router.push("/booking/home");
      }
    },
    viewBookingHistory() {
      // Get the active address
      var activeAddress = this.bookingState.activeAddress;
      if (!activeAddress) {
        return;
      }

      //Resets Step Form Index
      var id = activeAddress.id;
      this.$store.dispatch("setActiveAddress", activeAddress);
      var bookingManager = new BookingStateManager();
      bookingManager.upsertAddressMap(activeAddress);

      var userType = this.$store.getters.GET_PERSONAL_INFO.type;
      var routeOptions = { path: "history", query: { id: id } };
      switch (userType) {
        case "cso":
          let routeData = this.$router.resolve(routeOptions);
          window.open(routeData.href, "_blank");
          break;
        default:
          this.$router.push(routeOptions);
          break;
      }
    },
    checkAuthentication(email) {
      // Error 401 is Unauthorized
      var getEmail = email;
      if (!email) {
        return;
      }
      return new Promise((mainResolve, mainReject) => {
        new RetryWorker(
          10,
          5000,
          function () {
            return new Promise((resolve, reject) => {
              if (!email) {
                reject();
                return;
              }
              axios
                .get(process.env.MIX_API_URL + "list-favorites", {
                  params: {
                    email: getEmail,
                  },
                })
                .then((response) => {
                  resolve({
                    authenticated: true,
                  });
                })
                .catch((e) => {
                  if (e && e.response.status == 401) {
                    resolve({
                      authenticated: false,
                    });
                  } else {
                    reject();
                  }
                });
            });
          },
          function (result) {
            mainResolve(result.authenticated);
          }
        ).doWork();
      });
    },
  },
  watch: {
    $route: {
      handler(to, from) {
        if (!this.websiteTitle) {
          this.$store.dispatch("setWebsiteMetadata", { title: "unset" });
        }

        // Setup Document Title
        if (this.websiteTitle == "unset") {
          this.$store.dispatch("setWebsiteMetadata", { title: document.title });
        }

        // Apply Document Title if it exists
        if (this.websiteTitle != "unset") {
          if (to.meta.title && this.websiteTitle) {
            document.title = to.meta.title + " - " + this.websiteTitle;
          } else {
            document.title = this.websiteTitle;
          }
        }
      },
      immediate: true,
    },
  },
};
</script>
